module.exports = __webpack_public_path__ + "img/forte8.7eb99098.jpeg";